import Vue from "vue";

const MaterialListBoxInstance = Vue.extend(
  require("./materialListBox.vue").default
);
let instance = null;
let confirmPromise = null;
let confirmResolve = null;

let getInstance = () => {
  return new MaterialListBoxInstance({
    el: document.createElement("div")
  });
};

let close = () => {
  instance.close();
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null;
  if (confirmResolve) {
    confirmResolve(false);
    confirmResolve = null;
  }
  confirmPromise = null;
};

let MaterialListBox = (config, call) => {
  if (instance) {
    close();
  }
  instance = getInstance();

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise(resolve => {
    confirmResolve = resolve;
  });
  console.log("MaterialListBox call", call);
  instance.open(config, confirmResolve, call);

  return confirmPromise;
};

export default MaterialListBox;
